import { Component } from '@angular/core';
import {ArticlesService} from "../articles.service";
import {MenuItem} from "primeng/api";

@Component({
  selector: 'app-nav-header',
  templateUrl: './nav-header.component.html',
  styleUrls: ['./nav-header.component.css']
})
export class NavHeaderComponent {

  articlesService:ArticlesService;

  languages:MenuItem[] = [];

  constructor(_articlesService: ArticlesService) {
    this.articlesService = _articlesService;

    this.languages = [
      {
        label:'Ar',
        command: () => {
          this.articlesService.changeLocale(false);
        }
      },
      {
        label:'En',
        command: () => {
          this.articlesService.changeLocale(true);
        }
      }
    ]
  }

}
